module.exports = __webpack_public_path__ + "img/wallet-home2-xs.1225961c.png";